import {
  useMemo,
  type ReactNode,
} from 'react';
import {
  ActiveGroupContext,
  type ActiveGroupContextValue,
} from './active-group.js';

export interface ActiveGroupProviderProps {
  activeSlug: string | null | undefined;
  setActiveSlug: (slug: string | null) => void;
  children: ReactNode;
}

export function ActiveGroupProvider(props: ActiveGroupProviderProps): ReactNode {
  const { activeSlug, setActiveSlug, children } = props;
  const value = useMemo<ActiveGroupContextValue>(
    () => ({ activeSlug, setActiveSlug }),
    [activeSlug, setActiveSlug],
  );
  return (
    <ActiveGroupContext.Provider value={value}>
      {children}
    </ActiveGroupContext.Provider>
  );
}
